<template>
  <v-card outlined>
    <v-expansion-panels v-if="templateOptions && templateOptions.length" flat accordion>
      <template-option-block
        v-for="(templateOption, index) of templateOptions"
        :key="index"
        :original-template-options="originalTemplateOptions"
        :template-option="templateOption"
        :is-loading="isLoading"
        :readonly="readonly"
        @delete="onTemplateOptionDelete(index)"
        @input="onInput($event, index)"
      />
    </v-expansion-panels>
    <div class="pa-4">
      <v-btn color="primary" depressed block @click="onTemplateOptionAdd">
        <v-icon left>add</v-icon>
        <span>Add Template Option</span>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
const blankTemplateOption = index => ({
  template_option: `template_option_#${index}`,
  default_option: null,
  options: [],
})

export default {
  name: 'TemplateOptionGroup',
  components: {
    TemplateOptionBlock: () => import('./template-option-block'),
  },
  model: {
    prop: 'templateOptions',
  },
  props: {
    originalTemplateOptions: {
      type: Array,
      required: true,
    },
    templateOptions: {
      type: Array,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onTemplateOptionAdd() {
      this.$emit('input', [...this.templateOptions, blankTemplateOption(this.templateOptions.length + 1)])
    },
    onTemplateOptionDelete(index) {
      this.$emit('input', this.templateOptions.slice(0, index).concat(this.templateOptions.slice(index + 1)))
    },
    onInput(templateOption, index) {
      const input = this.templateOptions
        .slice(0, index)
        .concat(templateOption)
        .concat(this.templateOptions.slice(index + 1))

      this.$emit('input', input)
    },
  },
}
</script>
